import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import SignupReward from "../../assets/images/icons/catering-rewards/signup-reward.svg";
import DineReward from "../../assets/images/icons/catering-rewards/dine-reward.svg";
import RewardClimb from "../../assets/images/icons/catering-rewards/reward-climb.svg";

const StepCard = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: "#fff",
  borderRadius: "16px",
  padding: theme.spacing(4),
  boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
  transition: "all 0.3s ease",
  overflow: "hidden",
  height: "100%",
  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: "0 8px 30px rgba(0,0,0,0.1)",
  },
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(3),
  },
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  width: "64px",
  height: "64px",
  borderRadius: "50%",
  backgroundColor: "rgba(35, 136, 86, 0.05)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: theme.spacing(3),
  transition: "transform 0.3s ease",
  "&:hover": {
    transform: "scale(1.05)",
  },
}));

const ConnectingLine = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "32px",
  left: "95%",
  width: "calc(100% - 32px)",
  height: "2px",
  background: "linear-gradient(to right, #238856 30%, #2ab06f 90%)",
  opacity: 0.3,
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

const HowItWorks = () => {
  const steps = [
    {
      icon: SignupReward,
      title: "Signup for cashback rewards",
      description:
        "Join now for catering cashback rewards! Order directly from the restaurant's website and rack up points with every catering order.",
    },
    {
      icon: DineReward,
      title: "Earn More",
      description:
        "Order more, earn more. Order often and larger sizes to climb up the Levels (tiers) and earn even more points.",
    },
    {
      icon: RewardClimb,
      title: "Amazon.com Gift Card",
      description: "Convert your points to Amazon.com gift card, delivered straight to your inbox.",
    },
  ];

  return (
    <Box
      sx={{
        bgcolor: "grey.50",
        py: { xs: 6, md: 8 },
        px: 2,
        overflow: "hidden",
      }}
    >
      <Typography
        variant="h3"
        sx={{
          textAlign: "center",
          mb: { xs: 2, md: 4 },
          fontSize: { xs: "24px", sm: "28px", md: "34px" },
          fontWeight: 700,
        }}
      >
        How does it work?
      </Typography>

      <Box
        sx={{
          maxWidth: "1350px",
          mx: "auto",
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
          gap: 4,
          position: "relative",
        }}
      >
        {steps.map((step, index) => (
          <Box key={index} position="relative">
            {index < steps.length - 1 && <ConnectingLine />}
            <StepCard>
              {/* Decorative Circle */}
              <Box
                sx={{
                  position: "absolute",
                  top: -32,
                  right: -32,
                  width: 128,
                  height: 128,
                  borderRadius: "50%",
                  bgcolor: "success.light",
                  opacity: 0.05,
                }}
              />

              {/* Content */}
              <Box sx={{ position: "relative" }}>
                <IconWrapper>
                  <Box
                    component="img"
                    src={step.icon}
                    alt={step.title}
                    sx={{
                      width: { xs: 40, md: 48 },
                      height: { xs: 40, md: 48 },
                      objectFit: "contain",
                    }}
                  />
                </IconWrapper>

                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 600,
                    mb: 2,
                    fontSize: { xs: "18px", md: "20px" },
                  }}
                >
                  {step.title}
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    color: "text.secondary",
                    fontSize: { xs: "14px", md: "16px" },
                    lineHeight: 1.6,
                  }}
                >
                  {step.description}
                </Typography>
              </Box>
            </StepCard>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default HowItWorks;
